import { getCurrencyString } from '@theprintbar/shared';

export function getPriceLabel(price?: number[]) {
	if (!price?.length) return undefined;

	const [min, max] = price;

	if (!max || min === max) return getCurrencyString(min);
	return `${!min ? 'Under' : `${getCurrencyString(min)} -`} ${getCurrencyString(max)}`;
}
